import { nextTick } from 'vue';

export const waitForRepaint = async (): Promise<void> => {
    if (typeof window === 'undefined' || typeof requestAnimationFrame === 'undefined') {
        return;
    }

    await nextTick();

    await new Promise<void>((resolve) => {
        requestAnimationFrame(() => {
            resolve();
        });
    });
};
